/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';
import {
  adaptRplusEpubAsset,
  isRplusAssettocActiveForBook,
  isRplusEpubTitleType
} from '../common/RplusEpubPreviewUtils';

export default class EpubTocService extends BaseService {
  constructor() {
    super(constants.EPUB_TOC_DATA_FETCHED, 'epubTocStatus');
  }

  // eslint-disable-next-line no-unused-vars
  handleEvent(eventName, event) {
    const bookDetail = Framework.getStoreRegistry().getStore('booksState')?.bookDetail;
    if (!isRplusEpubTitleType(bookDetail?.titleType)) {
      return Promise.resolve(null);
    }
    const client = this.getClient('evergreen');
    if (!client) {
      return Promise.reject(new Error('Evergreen API client is not available'));
    }
    return client.get(`books/${event.id}/epub/assettoc`);
  }

  handleResponse(response, event) {
    const bookDetail = Framework.getStoreRegistry().getStore('booksState')?.bookDetail;
    if (isRplusAssettocActiveForBook(bookDetail, event?.id)) {
      const payload = response?.data?.data ?? response?.data;
      const adapted = adaptRplusEpubAsset(payload, bookDetail?.basePath);
      Framework.getStoreRegistry()
        .getStore('epubAsset')
        .set({
          data: {
            ...adapted,
            bookId: adapted?.bookId ?? event?.id
          }
        });
      Framework.getStoreRegistry().getStore('asset').set({ data: {} });
    }
  }

  handleError(error) {
    const { response } = error || {};
    if (response?.status === 401) {
      utils.redirectToLogin();
    }
  }
}
